import { keepPreviousData, useQuery } from '@tanstack/react-query';
import CustomAxios from '../../../utility/customAxios';
import { queryKeys } from '../queryKeys';
import { AccountTemplateResponse } from '../../../types/AccountTemplate';

type UseGetAllAccountTemplatesParams = {
  page?: number;
  per_page?: number;
  search?: string;
  filters?: {
    archived?: boolean;
  };
};

export type UseGetAllAccountTemplatesProps = {
  params?: UseGetAllAccountTemplatesParams;
  enabled?: boolean;
};

export const fetchAllAccountTemplates = async ({ params }: UseGetAllAccountTemplatesProps) => {
  const response = await CustomAxios.get<AccountTemplateResponse>(`account_templates`, { params });
  const { data } = response;
  return data;
};

export function useGetAllAccountTemplates({ params, enabled = true }: UseGetAllAccountTemplatesProps) {
  const queryKey: any = [queryKeys.allAccountTemplates, params];
  const query = useQuery({
    enabled,
    queryKey,
    queryFn: () => fetchAllAccountTemplates({ params }),
    placeholderData: keepPreviousData,
  });
  return query;
}
